<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-a" v-html="title" />
<!--        <div class="note">(*) Nội dung không được bỏ trống</div>-->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
// import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import formEdit from './add'
import moment from 'moment'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      categories: null,
      users: null,
      validationErrors: [],
      title: "Match",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      time_zone_local : moment.tz.guess(),
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editMatch' ? 'edit' : this.mode;
    // this.title = this.mode === 'edit' ? 'Edit club infomation' : this.title;
    
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    // await this.userLogin();
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_MATCH);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-match' });
    },
    async saveData(params) {
      // console.log("params",params)
      this.images = (params.images !== undefined && params.images !== null) ? params.images : [];
      var that = this;
      // if(this.mode == 'add'){
      // var uid = this.$store.getters.user

      //   let objects = {
      //     'updated_by' : uid,
      //   }
      //   console.log("asasasasa",params)
      //   await this.$apollo.mutate({
      //     mutation: DataServices.insertData('clubs'),
      //     variables: {
      //       'objects': objects
      //     }
      //   }).then(async (res) => {
      //     if (res.data[Object.keys(res.data)].affected_rows) {
      //       var returning = res.data[Object.keys(res.data)].returning[0];
      //       // // console.log("returning",returning)
      //       for (var i = 0 ; i < params.active_distance.length ; i++) {

      //         var objects_type = {
      //           banner_id: returning.id,
      //           type: params.active_distance[i],
      //         }
      //         await this.$apollo.mutate({
      //           mutation: DataServices.insertData('banner_type'),
      //           variables: {
      //             'objects': objects_type
      //           }
      //         })
      //       }
      //       console.log("iamgeee",params.images)
      //       if (params.images.length > 0){
      //         that.$CoreService.uploadImages(that.$constants.FOLDER_S3.BANNER,params.images).then((resImage) => {
      //           // console.log("resresres:",resImage);
      //           if (resImage){
      //             var objectImage  = resImage[0];//lấy 1 tấm hình
      //             that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.BANNER,returning.id,objectImage).then(() => {
      //               this.$commonFuction.is_loading(false);
      //               that.$toast.add({severity: 'success', summary: 'Notification', detail: 'Save success', life: 3000});
      //               this.$router.push({path: '/admin/list-banner'});
      //             });
      //           }
      //         });
      //       }
      //     }
          
      //   }).catch(async error => {
      //     console.log('error', error);
      //     that.$toast.add({
      //       severity: 'error',
      //       summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
      //       detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
      //       life: 3000
      //     });
      //     this.$commonFuction.is_loading(false);
      //   })
      // }
      // else{

        let objects = {
          statdium_id: params.stadium_id,
          number_of_player_id: params.number_of_player_id,
          date_time: params.date_time,
          score_club_1: params.score_club_1,
          score_club_2: params.score_club_2,
          updated_at : moment.tz(new Date(), this.time_zone_local)
        }
        var queryUpdate = `
            mutation update_match_multil($match_object: match_set_input,$match_halfs_objects: [match_half_insert_input!]!) {
              update_match(where: { id: {_eq: "${this.models.id}"}}, _set: $match_object) {
                affected_rows
                returning {
                  id
                }
              }
              delete_match_half(where: { match_id: {_eq: "${this.models.id}"}}) {
                returning {
                  id
                }
              }
              insert_match_half(
                objects: $match_halfs_objects
              ) {
                returning {
                  id
                }
              }

            }
          `;
          var match_halfs_objects = []
          for (let i = 0 ; i < params.match_halfs.length ; i++) {

              match_halfs_objects.push({
                match_id: this.models.id,
                owner_score: params.match_halfs[i].owner_score,
                client_score: params.match_halfs[i].client_score,
                half: (i+1)
              })
            }
          let variables = {
            match_object: objects,
            match_halfs_objects: match_halfs_objects
          };
          await this.$apollo.mutate({
            mutation: gql(queryUpdate),
            variables: variables
          }).then(async (res) => {
          console.log(res);
          that.redirectEdit();
        });
      // }
    },

    
    async userLogin() {
      var user = this.$store.getters.user;
      var {data} = await this.$apollo.query({
        query: DataServices.getList('accounts', {"fields" : "uid"}),
        variables: {
          where_key: {
            id: {'_eq': user}
          }
        },
        fetchPolicy: "network-only"
      });
      if (data && data[Object.keys(data)] !== undefined && data[Object.keys(data)].length > 0) {
        this.accountID = data[Object.keys(data)][0].uid;
      }
    },
    async redirectEdit() {
      var that = this;
      that.$commonFuction.is_loading(false);
      var router_back = {path: '/admin/list-match'};
      // if (!that.$commonFuction.isEmpty(router_back)){
      //   // that.page_transaction = ""+that.page_transaction
      //   router_back.query = { page_transaction: that.page_transaction.toString() };
      // }
      that.$router.push(router_back);
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save success', life: 3000 })
    },
    async getData(id) {
      // console.log("dasdasd");
      this.title = "Match";
      var {data} = await this.$apollo.query({
        query: DataServices.getList('match', {"fields" : 'id name_club_competition clubs{id club_name} competition_clubs{id club_name} match_halfs{id owner_score client_score} owner{id fullname} number_of_player{id code} date_time status stadium{id name}'}),
        variables: {
          where_key: {
            id: {'_eq': id},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var match = model[0]
        this.models.owner_logo = null;
        this.models.client_logo = null;
        console.log("this.models",this.models)
        if (!this.$commonFuction.isEmpty(this.models.clubs)) {
          var {listData} = await this.$CoreService.getFile(this.$constants.TYPE_IMAGE.LOGO_CLUB,this.models.clubs.id,0);
          if (listData.length > 0){
            this.models.owner_logo = listData[0].url;
          }
        }
        if (!this.$commonFuction.isEmpty(this.models.competition_clubs)) {
          var logo = await this.$CoreService.getFile(this.$constants.TYPE_IMAGE.LOGO_CLUB,this.models.competition_clubs.id,0);
          if (logo.listData.length > 0){
            this.models.client_logo = logo.listData[0].url;
          }
        }
        var title = '<span>Match</span>'
        if(match.clubs){
          title += '<span> - '+ match.clubs.club_name+'</span>'
        }
        if(match.competition_clubs){
          title += '<span style="font-weight: 400;"> vs </span><span>' + match.competition_clubs.club_name+'</span>'
        }else if(match.name_club_competition){
          title += '<span style="font-weight: 400;"> vs </span><span>' + match.name_club_competition+'</span>'
        }
        console.log("title==",title)
        this.title = title
        // if (!this.$commonFuction.isEmpty(this.models.clubs) && !this.$commonFuction.isEmpty(this.models.competition_clubs)) {
        //   this.title = this.title + ' - ' + this.models.clubs.club_name + ' <span class="no-bold">vs</span> ' + this.models.competition_clubs.club_name;
        // }
      }
      this.componentKey++;
    },
    async getCategories() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('category', {"fields" : "id name"}),
        fetchPolicy: "network-only"
      })
      this.categories = data[Object.keys(data)];
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.no-bold {
  font-weight: normal;
}
.manager-title-a {
  font-weight: bold;
  color: #1D3118;
  /* text-transform: capitalize; */
  font-size: 24px;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EEEEEE;
}
</style>